export async function efficiencyYBIFinishedUseCase(client_id, period, year, month, shipping_service, yegoDashboardRepository) {
    const result = await yegoDashboardRepository.efficiencyYBIFinishied(client_id, period, year, month, shipping_service);
    
    const info = await new yegoDashboardRepository.efficiency_finished_model(result.data.data);

    if (!info.isValid()) {
        throw new Error("Smart Carrier Answer Inválido");
    }

    return result.data.data;
}